class ContactBanner {
  constructor() {
    this.form = document.getElementById('ContactBannerForm');
    this.submitBtn = this.form?.querySelector('.contact-banner__submit-btn');
    this.fields = this.form?.querySelectorAll('.contact-banner__field input, .contact-banner__field textarea');
    
    this.init();
  }

  init() {
    if (!this.form) return;
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Form submission
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    
    // Real-time validation
    this.fields.forEach(field => {
      field.addEventListener('blur', () => this.validateField(field));
      field.addEventListener('input', () => this.clearFieldError(field));
    });
    
    // Prevent form submission on Enter key in textarea
    const textarea = this.form.querySelector('textarea');
    if (textarea) {
      textarea.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.ctrlKey) {
          this.form.dispatchEvent(new Event('submit'));
        }
      });
    }
  }

  validateField(field) {
    const value = field.value.trim();
    const fieldContainer = field.closest('.contact-banner__field');
    
    // Remove existing error states
    this.clearFieldError(field);
    
    // Check if field is required
    if (field.hasAttribute('required') && !value) {
      this.showFieldError(field, 'Este campo es obligatorio');
      return false;
    }
    
    // Email validation using HTML5 validation
    if (field.type === 'email' && value) {
      if (!field.checkValidity()) {
        this.showFieldError(field, 'Por favor ingresa un email válido');
        return false;
      }
    }
    
    // Phone validation using HTML5 validation
    if (field.type === 'tel' && value) {
      if (!field.checkValidity()) {
        this.showFieldError(field, 'Por favor ingresa un número de teléfono válido');
        return false;
      }
    }
    
    // Show success state
    fieldContainer.classList.add('success');
    return true;
  }

  showFieldError(field, message) {
    const fieldContainer = field.closest('.contact-banner__field');
    fieldContainer.classList.add('error');
    
    // Remove existing error message
    const existingError = fieldContainer.querySelector('.contact-banner__field-error');
    if (existingError) {
      existingError.remove();
    }
    
    // Add new error message
    const errorElement = document.createElement('span');
    errorElement.className = 'contact-banner__field-error';
    errorElement.textContent = message;
    fieldContainer.appendChild(errorElement);
  }

  clearFieldError(field) {
    const fieldContainer = field.closest('.contact-banner__field');
    fieldContainer.classList.remove('error', 'success');
    
    const errorElement = fieldContainer.querySelector('.contact-banner__field-error');
    if (errorElement) {
      errorElement.remove();
    }
  }

  validateForm() {
    let isValid = true;
    
    this.fields.forEach(field => {
      if (!this.validateField(field)) {
        isValid = false;
      }
    });
    
    return isValid;
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    if (!this.validateForm()) {
      this.showMessage('Por favor corrige los errores en el formulario', 'error');
      return;
    }
    
    // Show loading state
    this.setLoadingState(true);
    
    try {
      // Get form data
      const formData = new FormData(this.form);
      const data = Object.fromEntries(formData.entries());
      
      // Send notification email if configured
      await this.sendNotification(data);
      
      // Show success message
      this.showMessage('¡Gracias! Tu mensaje ha sido enviado correctamente.', 'success');
      
      // Reset form
      this.form.reset();
      this.fields.forEach(field => {
        field.closest('.contact-banner__field').classList.remove('success');
      });
      
    } catch (error) {
      console.error('Error submitting form:', error);
      this.showMessage('Hubo un error al enviar el mensaje. Por favor intenta nuevamente.', 'error');
    } finally {
      this.setLoadingState(false);
    }
  }

  async sendNotification(data) {
    // This would typically be handled by Shopify's contact form
    // But we can add additional notification logic here
    
    const notificationEmail = this.form.dataset.notificationEmail;
    const notificationSubject = this.form.dataset.notificationSubject || 'Nuevo contacto desde el sitio web';
    
    if (notificationEmail) {
      // You could send an additional notification here
      // For now, we'll just log it
      console.log('Notification would be sent to:', notificationEmail);
      console.log('Subject:', notificationSubject);
      console.log('Data:', data);
    }
  }

  setLoadingState(loading) {
    if (loading) {
      this.form.classList.add('loading');
      this.submitBtn.classList.add('loading');
      this.submitBtn.disabled = true;
    } else {
      this.form.classList.remove('loading');
      this.submitBtn.classList.remove('loading');
      this.submitBtn.disabled = false;
    }
  }

  showMessage(message, type = 'info') {
    // Remove existing messages
    const existingMessages = this.form.querySelectorAll('.contact-banner__message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create new message
    const messageElement = document.createElement('div');
    messageElement.className = `contact-banner__message contact-banner__message--${type}`;
    messageElement.textContent = message;
    
    // Insert at the beginning of the form
    this.form.insertBefore(messageElement, this.form.firstChild);
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      if (messageElement.parentNode) {
        messageElement.remove();
      }
    }, 5000);
    
    // Scroll to message (only if not already in view)
    const rect = messageElement.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ContactBanner();
});

// Initialize for dynamic content (if using AJAX)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#ContactBannerForm')) {
    new ContactBanner();
  }
});
